(function () {
  'use strict';

  // ---- Pure validators (shared by the browser init + Node unit tests) ----
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function isValidEmail(v) {
    return EMAIL_RE.test((v == null ? '' : String(v)).trim());
  }

  // raw = the visible national number; dialDigits = digit count of the selected dial code.
  // Tolerant E.164: digits + common separators only; 4..(15 - dialDigits) digits.
  function isValidPhone(raw, dialDigits) {
    var s = (raw == null ? '' : String(raw)).trim();
    if (!s || /[^\d\s()+.\-]/.test(s)) return false;   // reject letters / stray symbols
    var d = s.replace(/\D/g, '');
    var maxNational = Math.max(4, 15 - (dialDigits || 0));
    return d.length >= 4 && d.length <= maxNational;
  }

  function init(section) {
    var form = section.querySelector('form');
    if (!form) return;
    var countrySel = section.querySelector('[data-cf-country]');
    var dialEl = section.querySelector('[data-cf-dialcode]');
    var phoneNum = section.querySelector('[data-cf-phone]');
    var phoneFull = section.querySelector('[data-cf-phone-full]');
    var phoneError = section.querySelector('[data-cf-phone-error]');
    var emailField = section.querySelector('[data-cf-email]');
    var emailError = section.querySelector('[data-cf-email-error]');
    var submitBtn = section.querySelector('[data-cf-submit]');
    var fieldsBox = section.querySelector('[data-cf-fields]');
    var successBox = section.querySelector('[data-cf-success]');
    var resetBtn = section.querySelector('[data-cf-reset]');
    var sink = section.querySelector('[data-cf-sink]');
    var reqFields = Array.prototype.slice.call(section.querySelectorAll('[data-cf-req]'));
    var submitted = false;

    function dialDigits() {
      return ((dialEl && dialEl.textContent) || '').replace(/\D/g, '').length;
    }
    function phoneValid() {
      return isValidPhone(phoneNum && phoneNum.value, dialDigits());
    }
    function fieldOk(el) {
      var v = (el.value || '').trim();
      if (!v) return false;
      if (el.hasAttribute('data-cf-email')) return isValidEmail(v);
      if (el.hasAttribute('data-cf-phone')) return phoneValid();
      return true;
    }
    function validate() {
      var ok = reqFields.length > 0 && reqFields.every(fieldOk) &&
        (!dialEl || /\d/.test(dialEl.textContent || ''));
      if (phoneError && phoneNum) {
        phoneError.hidden = !(phoneNum.value.trim() && !phoneValid());
      }
      if (submitBtn) submitBtn.disabled = !ok;
      return ok;
    }

    // Populate the country dropdown + wire the dial code.
    if (countrySel && window.MS_COUNTRIES) {
      var frag = document.createDocumentFragment();
      window.MS_COUNTRIES.forEach(function (c) {
        var o = document.createElement('option');
        o.value = c.n;
        o.textContent = c.n;
        o.setAttribute('data-dial', c.d);
        frag.appendChild(o);
      });
      countrySel.appendChild(frag);
      countrySel.addEventListener('change', function () {
        var opt = countrySel.options[countrySel.selectedIndex];
        var dial = (opt && opt.getAttribute('data-dial')) || '';
        if (dialEl) {
          dialEl.textContent = dial;
          dialEl.classList.toggle('ms-phone__code--empty', !dial);
        }
        if (phoneNum) {                 // number box unlocks only once a country is set
          phoneNum.disabled = !dial;
          if (!dial) phoneNum.value = '';
        }
        validate();
      });
    }

    reqFields.forEach(function (el) {
      el.addEventListener('input', validate);
      el.addEventListener('change', validate);
    });

    // Email: hint appears when the field is left invalid, clears as it's fixed.
    if (emailField && emailError) {
      emailField.addEventListener('blur', function () {
        var v = emailField.value.trim();
        emailError.hidden = !(v && !isValidEmail(v));
      });
      emailField.addEventListener('input', function () {
        var v = emailField.value.trim();
        if (!v || isValidEmail(v)) emailError.hidden = true;
      });
    }

    // Post the native form into the hidden iframe so the page never reloads
    // (keeps Shopify's hCaptcha/spam protection working, unlike an AJAX fetch).
    if (sink && sink.getAttribute('name')) {
      form.setAttribute('target', sink.getAttribute('name'));
    }
    form.addEventListener('submit', function (e) {
      if (!validate()) { e.preventDefault(); return; }
      if (phoneFull) {                  // combine dial + national into the HIDDEN field only
        var dial = ((dialEl && dialEl.textContent) || '').trim();
        var num = ((phoneNum && phoneNum.value) || '').trim();
        phoneFull.value = (dial + ' ' + num).trim();
      }
      if (submitBtn) submitBtn.disabled = true;
      submitted = true;
    });

    function showSuccess() {
      if (fieldsBox) fieldsBox.hidden = true;
      if (sink) sink.classList.remove('ms-sink--shown');
      if (successBox) successBox.hidden = false;
      if (resetBtn) resetBtn.focus();
    }
    function resetForm() {
      form.reset();
      if (successBox) successBox.hidden = true;
      if (fieldsBox) fieldsBox.hidden = false;
      if (dialEl) { dialEl.textContent = ''; dialEl.classList.add('ms-phone__code--empty'); }
      if (phoneNum) phoneNum.disabled = true;
      if (phoneFull) phoneFull.value = '';
      if (phoneError) phoneError.hidden = true;
      if (emailError) emailError.hidden = true;
      if (sink) sink.classList.remove('ms-sink--shown');
      submitted = false;
      if (submitBtn) submitBtn.disabled = true;
    }
    if (resetBtn) resetBtn.addEventListener('click', resetForm);

    if (sink) {
      sink.addEventListener('load', function () {
        if (!submitted) return;                 // ignore the initial about:blank load
        var href = null;
        try { href = (sink.contentWindow && sink.contentWindow.location.href) || ''; }
        catch (err) { href = null; }            // cross-origin / XFO => unreadable
        if (href === null || /contact_posted=true/.test(href)) {
          submitted = false;
          showSuccess();
        } else if (/\/challenge/.test(href)) {  // spam challenge — reveal the frame to solve it
          if (fieldsBox) fieldsBox.hidden = true;
          sink.classList.add('ms-sink--shown');
        } else {
          submitted = false;
          if (submitBtn) submitBtn.disabled = false;
        }
      });
    }

    // Non-JS fallback: a native (top-window) submit reloads with ?contact_posted=true.
    if (/[?&]contact_posted=true/.test(window.location.search)) {
      showSuccess();
      try { history.replaceState(null, '', window.location.pathname); } catch (err) {}
    }

    validate();
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { isValidEmail: isValidEmail, isValidPhone: isValidPhone };
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-section-type="contact-enhanced"]').forEach(init);
    });
    // Theme editor: re-initialise a re-rendered contact section (fires only in the editor).
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-section-type="contact-enhanced"]').forEach(init);
    });
  }
})();
